import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { SERVICES, IMG } from "@/data/site";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import FinalCTA from "@/components/home/FinalCTA";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        title="Waterproofing Services in Jaipur"
        subtitle="From roofs to basements, tanks to façades — 20 engineered waterproofing solutions backed by up to 15-year warranty. Explore each service in detail."
        image={IMG.commercial}
        crumbs={[{ label: "Services" }]}
      />
      <section className="bg-soft-grey py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => {
              const Icon = Icons[s.icon] || Icons.Droplets;
              return (
                <StaggerItem key={s.slug}>
                  <Link to={`/services/${s.slug}`} data-testid={`service-${s.slug}`} className="group block bg-white rounded-lg overflow-hidden border border-slate-200 h-full hover:shadow-xl hover:shadow-navy/10 hover:-translate-y-1 transition-all duration-500">
                    <div className="relative h-44 overflow-hidden">
                      <img src={s.image} alt={`${s.title} in Jaipur`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                      <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/70 to-transparent" />
                      <div className="absolute bottom-3 left-3 h-11 w-11 rounded-md glass-dark flex items-center justify-center">
                        <Icon className="h-5 w-5 text-sky" />
                      </div>
                    </div>
                    <div className="p-5">
                      <h3 className="font-display text-lg font-bold text-navy-deep group-hover:text-royal transition-colors">{s.title}</h3>
                      <p className="text-slate-600 text-sm mt-2 line-clamp-2">{s.short}</p>
                      <span className="inline-flex items-center gap-1 text-royal text-sm font-semibold mt-3">Learn more <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" /></span>
                    </div>
                  </Link>
                </StaggerItem>
              );
            })}
          </Stagger>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
}
